export default [
  {
    key: 'name',
    label: '単価種別',
    style: {
    }
  }, 
  {
    key: 'price',
    label: '単価',
    style: {
    }
  },
  {
      key: 'time',
      label: '時間(分)',
      style: {
      }
  },
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/price/listHeader.js